import styled, { css, DefaultTheme } from 'styled-components';

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
  return css`
    position: absolute;

    &[data-position='TopLeft'],
    &[data-position='CenterLeft'],
    &[data-position='TopRight'],
    &[data-position='CenterRight'] {
      @media ${theme.mq.max.tablet} {
        top: 4.5em;
        left: 3.875em;
      }
    }

    &[data-position='BottomLeft'],
    &[data-position='BottomRight'] {
      @media ${theme.mq.max.tablet} {
        bottom: 4.5em;
        left: 3.875em;
      }
    }

    &[data-position='TopLeft'] {
      @media ${theme.mq.min.tablet} {
        bottom: -4.625em;
        left: 0;
      }
    }

    &[data-position='CenterLeft'] {
      @media ${theme.mq.min.tablet} {
        bottom: -4.625em;
        left: 0;
      }
    }

    &[data-position='BottomLeft'] {
      @media ${theme.mq.min.tablet} {
        bottom: 3em;
        left: 0;
      }
    }

    &[data-position='TopRight'] {
      @media ${theme.mq.min.tablet} {
        bottom: -4.625em;
        right: 0;
      }
    }

    &[data-position='CenterRight'] {
      @media ${theme.mq.min.tablet} {
        bottom: -4.625em;
        right: 0;
      }
    }

    &[data-position='BottomRight'] {
      @media ${theme.mq.min.tablet} {
        bottom: 3em;
        right: 0;
      }
    }
  `;
  }}
`;
